import { useEffect, useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import './App.css';
import './styles/Animations.css';

import Nav from './components/Nav';
import About from './pages/About';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import IEarnGold from './pages/IEarnGold';
import Introduction from './pages/Introduction';

function App() {
  const location = useLocation();
  const pageNodeRefs = useRef({});

  if (!pageNodeRefs.current[location.pathname]) {
    pageNodeRefs.current[location.pathname] = { current: null };
  }

  const pageNodeRef = pageNodeRefs.current[location.pathname];

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return (
    <div className="app">
      <Nav />
      <TransitionGroup className="main-content">
        <CSSTransition
          key={location.pathname}
          nodeRef={pageNodeRef}
          timeout={700}
          classNames="ryon-page-transition"
        >
          <div ref={pageNodeRef}>
            <Routes location={location}>
              <Route path="/" element={<Introduction />} />
              <Route path="/i-earn-gold" element={<IEarnGold />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
}

export default App;
